<div class="tickets-flex">
  <div>
    <div class="map-statistics-buttons">
      <mat-button-toggle-group
        (change)="currentPage = $event.value"
      >
        <mat-button-toggle
          [value]="'map'"
          [checked]="'map' === currentPage"
        >Térkép</mat-button-toggle>
        <mat-button-toggle
          [value]="'statistics'"
          [checked]="'statistics' === currentPage"
        >Statisztika</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-selected-ticket [refSubject]=refSubject *ngIf="currentPage === 'map'" [project]="project"></app-selected-ticket>
    <app-stat-project
      *ngIf="currentPage === 'statistics'"
      [instance]="project"
    ></app-stat-project>
  </div>
  <div class="tickets-flex-separator"></div>
  <div class="ticket-list-header">
    <div class="tickets-header" [class.batch]="showBatchActions" [class.filter]="showMoreFilter">
      <div class="header-title-row">
        <div class="tickets-header-title">TICKETEK ({{page.docs.length}})</div>
        <app-button
          (click)="showMoreFilter = !showMoreFilter"
          [title]="showMoreFilter ? 'Kevesebb szűrő' : 'Több szűrő'"
          [fontSize]="14"
          [customColor]="'green'"
          [inverz]="true"
        ></app-button>
        <app-button
          (click)="export()"
          [title]="'Export'"
          [fontSize]="14"
          [customColor]="'green'"
          [inverz]="true"
        ></app-button>
        <app-button
          (click)="accordion.openAll()"
          [title]="'Kinyit mind'"
          [fontSize]="14"
          [customColor]="'green'"
          [inverz]="true"
        ></app-button>
        <app-button
          (click)="accordion.closeAll()"
          [title]="'Becsuk mind'"
          [fontSize]="14"
          [customColor]="'green'"
          [inverz]="true"
        ></app-button>
      </div>
      <div class="tickets-header-selectors">
        <div class="selector">
          <mat-form-field>
            <mat-label>Státusz</mat-label>
            <mat-select [value]="status" (selectionChange)="selectStatus($event.value)">
              <mat-option>Összes</mat-option>
              <mat-option *ngFor="let oneStatus of statuses" [value]="oneStatus">
                {{oneStatus.niceName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="selector">
          <mat-form-field>
            <mat-label>Felhasználó</mat-label>
            <mat-select [value]="selectedUser" (selectionChange)="selectUser($event.value)">
              <mat-option>Összes</mat-option>
              <mat-option *ngFor="let currUser of users" [value]="currUser">
                {{currUser.lastName}} {{currUser.firstName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="selector">
          <mat-form-field>
            <mat-label>Intervallum</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate (dateChange)="selectStart($event.value)">
              <input matEndDate (dateChange)="selectEnd($event.value)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      <div class="tickets-header-selectors" [class.hide]="!showMoreFilter">
        <div class="selector">
          <mat-form-field>
            <mat-label>Kategória</mat-label>
            <mat-select [value]="status" (selectionChange)="selectCategory($event.value)">
              <mat-option>Összes</mat-option>
              <mat-option *ngFor="let category of categories" [value]="category">
                {{category.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="selector cat">
          <mat-form-field>
            <mat-label>Kerület</mat-label>
            <mat-select [value]="status" (selectionChange)="selectDistrict($event.value)">
              <mat-option>Összes</mat-option>
              <mat-option value="1">I.</mat-option>
              <mat-option value="2">II.</mat-option>
              <mat-option value="3">III.</mat-option>
              <mat-option value="4">IV.</mat-option>
              <mat-option value="5">V.</mat-option>
              <mat-option value="6">VI.</mat-option>
              <mat-option value="7">VII.</mat-option>
              <mat-option value="8">VIII.</mat-option>
              <mat-option value="9">IX.</mat-option>
              <mat-option value="10">X.</mat-option>
              <mat-option value="11">XI.</mat-option>
              <mat-option value="12">XII.</mat-option>
              <mat-option value="13">XIII.</mat-option>
              <mat-option value="14">XIV.</mat-option>
              <mat-option value="15">XV.</mat-option>
              <mat-option value="16">XVI.</mat-option>
              <mat-option value="17">XVII.</mat-option>
              <mat-option value="18">XVIII.</mat-option>
              <mat-option value="19">XIX.</mat-option>
              <mat-option value="20">XX.</mat-option>
              <mat-option value="21">XXI.</mat-option>
              <mat-option value="22">XXII.</mat-option>
              <mat-option value="23">XXIII.</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="selector">
          <mat-form-field>
            <mat-label>Címkereső</mat-label>
            <input
              type="text"
              placeholder="Pick one"
              aria-label="Number"
              matInput
              [(ngModel)]="searchTerm"
              [matAutocomplete]="auto"
              (input)="buffer()"
              [ngStyle]="{ 'color' : 'white' }"
            >
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of searchList" [value]="option" (click)="searchByTerm()">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="tickets-header-selectors multi" [class.hide]="!showMoreFilter">
        <div *ngFor="let att of searchableAttributes" class="selector multi">
          <mat-form-field *ngIf="!att.isDate">
            <mat-label>{{att.name}}</mat-label>
            <input
              type="text"
              placeholder="Pick one"
              aria-label="Number"
              matInput
              [value]="searchables[att.id].value"
              (input)="changeSearchable(att.id, $event.target.value)"
              [ngStyle]="{ 'color' : 'white' }"
            >
          </mat-form-field>
          <mat-form-field *ngIf="att.isDate">
            <mat-label>{{att.name}}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate (dateChange)="searchableStart(att.id, $event.value)">
              <input matEndDate (dateChange)="searchableEnd(att.id, $event.value)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      <div class="header-batch-actions" [class.hide]="!showBatchActions">
        <div class="header-batch-text">
          <div>Kiválasztott ticketek száma:</div>
          <div>{{selectedTickets.length}} darab</div>
        </div>
        <div class="header-batch-actions-buttons">
          <app-button
            [matMenuTriggerFor]="acceptBatchMenu"
            (click)="$event.stopPropagation()"
            [icon]="'done'"
            [fontSize]="24"
            [inverz]="true"
            [customColor]="'green'"
          ></app-button>
          <app-button
            [matMenuTriggerFor]="delSelectedMenu"
            (click)="$event.stopPropagation()"
            [icon]="'delete'"
            [fontSize]="24"
            [inverz]="true"
            [customColor]="'red'"
          ></app-button>
          <app-button
            (click)="clearSelectedTickets()"
            [icon]="'close'"
            [fontSize]="24"
            [inverz]="true"
          ></app-button>
        </div>
      </div>
      <mat-menu class="menu-for-delete" #delSelectedMenu="matMenu" xPosition="before">
        <div class="ticket-delete-title">Biztosan törli mindet?</div>
        <div
          class="ticket-delete-option"
          (click)="deleteSelectedTickets()"
        >Igen, mind a {{selectedTickets.length}} darabot</div>
        <div
          class="ticket-delete-option"
        >nem</div>
      </mat-menu>
      <mat-menu class="menu-for-status" #acceptBatchMenu="matMenu" xPosition="before">
        <div
          *ngFor="let status of statuses"
          class="ticket-accept-option"
          (click)="setStatusOnSelectedTickets(status)"
        >{{status.niceName}}</div>
      </mat-menu>
    </div>
    <div class="no-match" *ngIf="isObject">Réteg: {{clickedTicket.externalLayer.name}}{{getCustomAttributes()}}</div>
    <div class="no-match" *ngIf="page.docs.length === 0">Nincs találat</div>
    <mat-accordion class="ticket-list" multi>
      <mat-expansion-panel *ngFor="let item of page.docs;" [class.active]="checkSelection(item.id)" [class.clicked]="clickedTicket.ticketId === item.id" class="ticket-container">
        <mat-expansion-panel-header (click)="$event.stopPropagation()" [attr.data-id]="item.id" collapsedHeight="'16px'" expandedHeight="'16px'">
          <span>
            <span>{{item.nr}} - {{item.createdBy.firstName}}. {{item.createdBy.lastName}} - {{item.ticketStatus.niceName}}</span>
            <mat-icon *ngIf="item.hasImage" class="material-icons-outlined list-icon">image</mat-icon>  
            <mat-icon *ngIf="item.hasSound" class="material-icons-outlined list-icon">hearing</mat-icon>  
            <br/>
            <span>{{item.ticketCategory.name}}</span>
            <br/>
            <span class="address">{{item.address}}</span><span class="date">Létrehozva: {{item.createdAt.toString().slice(0, 10)}} | {{item.createdAt.toString().slice(11, 16)}}</span>
          </span>
          <div class="action-container">
            <mat-slide-toggle
              (click)="$event.stopPropagation()"
              [checked]="checkSelection(item.id)"
              (change)="select(item)"
            ></mat-slide-toggle>
            <app-button
              [matMenuTriggerFor]="acceptMenu"
              (click)="$event.stopPropagation()"
              [icon]="'done'"
              [fontSize]="18"
              [customColor]="'green'"
            ></app-button>
            <app-button
              (click)="openEditModal($event, item)"
              [icon]="'edit'"
              [fontSize]="18"
              [customColor]="'yellow'"
            ></app-button>
            <app-button
              [matMenuTriggerFor]="delMenu"
              (click)="$event.stopPropagation()"
              [icon]="'delete'"
              [fontSize]="18"
              [customColor]="'red'"
            ></app-button>
            <mat-menu class="menu-for-status" #acceptMenu="matMenu" xPosition="before">
              <div
                *ngFor="let status of statuses"
                class="ticket-accept-option"
                (click)="setStatus(status, item)"
              >{{status.niceName}}</div>
            </mat-menu>
            <mat-menu class="menu-for-delete" #delMenu="matMenu" xPosition="before">
              <div class="ticket-delete-title">Biztosan törli?</div>
              <div
                class="ticket-delete-option"
                (click)="deleteTicket(item)"
              >Igen</div>
              <div
                class="ticket-delete-option"
              >nem</div>
            </mat-menu>
          </div>
          </mat-expansion-panel-header>
        <div *ngIf="item.externalFeatures && item.externalFeatures[0] && item.externalFeatures[0].objectId" class="ticket-attributes">
          <div class="description-title">Objektum ID</div>
          <div>{{item.externalFeatures[0].objectId}}</div>
        </div>
        <div *ngIf="item.externalFeatures && item.externalFeatures[0] && item.externalFeatures[0].objectId" class="ticket-attributes">
          <div class="description-title">Réteg URL</div>
          <div>{{item.externalFeatures[0].externalLayer.url}}</div>
        </div>
        <div class="ticket-attributes">
          <div>Cím</div>
          <div>{{item.address}}</div>
        </div>
        <div *ngFor="let attribute of item.ticketAttributeValues;" class="ticket-attributes">
          <div>{{attribute.name}}</div>
          <div>{{itemValue(attribute)}}</div>
        </div>
        <div *ngIf="item.description && item.description.length > 0" class="ticket-attributes">
          <div class="description-title">Megjegyzés</div>
          <div>{{item.description}}</div>
        </div>
        <div class="ticket-attributes">
          <app-button class="half" [title]="'Képek'" [fullWidth]="true" (click)="gallery(item)"></app-button>
          <app-button class="half" [title]="'Hangjegyzetek'" [fullWidth]="true" (click)="sounds(item)"></app-button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
